import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as vaultSelectors from '@app/root-store/vault-store/vault.selector';
import { MY_FORMATS } from '@app/shared/component/accessibility-settings/accessibility-settings.component';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'form-preview-setup',
  templateUrl: './form-preview-setup.component.html',
  styleUrls: ['./form-preview-setup.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormPreviewSetupComponent implements OnInit, OnDestroy {
  @Input() JsonDataExtractedData;
  @Input() fId = 27;
  documentForm: UntypedFormGroup;
  subscription: Subscription = new Subscription();
  Form1;
  disablesingleFielFormValidator = false;
  arrayItems = [];
  constructor(private store: Store, private formBuilder: UntypedFormBuilder, private cd: ChangeDetectorRef) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.documentForm = this.formBuilder.group(
      {
        dynamicFieldsForm: new UntypedFormArray([]),
      },
      {
        validators: [this.relationshipTypeThreeConditionallyRequiredValidator.bind(this)],
      }
    );
    this.getFormById();
  }
  getFormById() {
    this.subscription.add(
      this.store.select(vaultSelectors.getCurrentFormsById(this.fId)).subscribe((response) => {
        this.Form1 = response.template;

        this.arrayItems = this.Form1[0]['singleFieldForm'];
        this.t.clear();
        const test = this.formBuilder.group({});
        this.arrayItems.forEach(function (value) {
          if (value['type'] === 'MultiPleDropDown') {
            test.addControl(value.formControlName, new UntypedFormControl(''));
            value['data'].forEach((childcontrols) => {
              childcontrols['template'].forEach((child) => {
                test.addControl(child.formControlName, new UntypedFormControl(''));
              });
            });
          } else if (value['type'] === 'Section') {
          } else if (value['type'] == 'email') {
            test.addControl(value.formControlName, new UntypedFormControl(''));
          } else {
            test.addControl(value.formControlName, new UntypedFormControl(''));
          }
        });
        this.t.push(test);
        this.setDataFromAIResponse();
        this.cd.detectChanges();
      })
    );
  }
  // convenience getters for easy access to form fields
  get f() {
    return this.documentForm.controls;
  }

  get t() {
    return this.f.dynamicFieldsForm as UntypedFormArray;
  }
  passJsonData(data) {
    this.JsonDataExtractedData = data;
    this.setDataFromAIResponse();
  }

  setDataFromAIResponse() {
    Object.entries(this.JsonDataExtractedData).forEach(([key, value]) => {
      let findIndex =
        this.arrayItems.findIndex((x) => x.label.trim() == key) != -1
          ? this.arrayItems.findIndex((x) => x.label.trim() == key)
          : this.arrayItems.findIndex((x) => x.formControlName.trim() == key);
      if (findIndex == -1) {
        let newKey = key.replace(/_/g, ' ').toLocaleLowerCase();
        findIndex =
          this.arrayItems.findIndex((x) => x.label.trim().toLocaleLowerCase() == newKey) != -1
            ? this.arrayItems.findIndex((x) => x.label.trim().toLocaleLowerCase() == newKey)
            : this.arrayItems.findIndex((x) => x.formControlName.trim().toLocaleLowerCase() == newKey);
      }
      if (findIndex >= 0) {
        try {
          if (this.arrayItems[findIndex].type == 'date') {
            this.documentForm.controls.dynamicFieldsForm['controls'][0].controls[this.arrayItems[findIndex].formControlName].setValue(
              new Date(value.toString())
            );
          } else {
            this.documentForm.controls.dynamicFieldsForm['controls'][0].controls[this.arrayItems[findIndex].formControlName].setValue(value);
          }
        } catch (error) {}
      }
    });
    this.cd.detectChanges();
  }
  relationshipTypeThreeConditionallyRequiredValidator(formGroup: UntypedFormGroup) {
    if (formGroup.controls.dynamicFieldsForm['controls'].length > 0) {
      const data = Object.keys(formGroup.controls.dynamicFieldsForm['controls'][0].value);
      const formValue = this.Form1[0]['singleFieldForm'];
      this.disablesingleFielFormValidator = false;
      data.forEach((element) => {
        const data = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][element];
        const currentFOrm = formValue.find((obj) => obj.formControlName == element);
        if (formValue.findIndex((obj) => obj.formControlName == element) != -1) {
          if (currentFOrm['type'] == 'email') {
            const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (data != '' && !mailformat.test(data)) {
              this.disablesingleFielFormValidator = true;
              return { invalidCustom: true };
            }
          }
          if (currentFOrm['isRequired']) {
            if (data == '') {
              this.disablesingleFielFormValidator = true;
              return { invalidCustom: true };
            }
          }
        } else {
          const AllMultiDropDownList = formValue.filter((obj) => obj.type == 'MultiPleDropDown');
          let dropDownList = [];
          AllMultiDropDownList.forEach((multidropDownList) => {
            multidropDownList['data'].forEach((list) => {
              dropDownList = dropDownList.concat(list['template']);
            });
          });
          const data = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][element];
          if (dropDownList.findIndex((obj) => obj.formControlName == element) != -1) {
            const currentFOrm = dropDownList.find((obj) => obj.formControlName == element);
            const parentformDat = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][currentFOrm['parentformControlName']];
            if (parentformDat == currentFOrm['parentformControlValue']) {
              if (currentFOrm['type'] == 'email') {
                const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                if (data != '' && !mailformat.test(data)) {
                  this.disablesingleFielFormValidator = true;
                  return { invalidCustom: true };
                }
              }
              if (currentFOrm['isRequired']) {
                if (data == '') {
                  this.disablesingleFielFormValidator = true;
                  return { invalidCustom: true };
                }
              }
            }
          }
        }
      });
      return null;
    }
  }
}
